import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { mapGetters } from "vuex";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import ApiService from "@/core/services/api.service";
export default {
  props: {
    modal: {
      default: false
    },
    value: Boolean
  },

  name: "shop-post-tags",
  data() {
    return {
      requiredRule: [v => !!v || "Field is required"],
      isSaving: false,
      shopPostId: null,
      valid: false,
      tags: []
    };
  },
  created() {
    this.shopPostId = this.$route.params.shopPostId;
    this.$log.debug("shoppostid: ", this.shopPostId);
    this.$store.dispatch(SET_BREADCRUMB, [{ title: this.$i18n.t ( 'pages.shopPosts.shopPostTags' ) }]);

    if (this.shopPostId != null) {
      ApiService.get(`api/shop-posts`, `${this.shopPostId}/tags`)
        .then(response => {
          this.$log.debug("tags response: ", response.data);
          this.tags = response.data;
        })
        .catch(error => {
          this.$log.error("Error: ", error);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    }
  },
  methods: {
    previousState() {
      this.$router.go(-1);
    },
    validateAndSave() {
      if (this.$refs.form.validate()) {
        this.saveShopPostTags(this.tags, this.shopPostId);
      }
    },
    saveShopPostTags(tags, shopPostId) {
      this.loading = true;
      this.isSaving = true;
      this.$log.debug("Tags for saving: " + tags);
      this.$log.debug("shopPostId: " + shopPostId);
      let shopPostTags = {};
      shopPostTags["shopPostId"] = shopPostId;
      shopPostTags["tags"] = tags;
      ApiService.post(`api/shop-posts/tags`, shopPostTags)
          .then(response => {
            this.$log.debug("Shop post tags created: " + response);
            this.$emit("shopPostTagsCreated", "shopPostTagsCreated");
          })
          .catch(error => {
            this.$log.error("Error: ", error);
            this.errored = true;
          })
          .finally(() => {
            this.loading = false;
            this.isSaving = false;
            this.previousState();
          });
    }
  },
  computed: {
    ...mapGetters(["currentUserPersonalInfo"]),
    show: {
      get() {
        return this.value;
      },
      set(value) {
        if (!value) {
          this.$emit("input", value);
        }
      }
    }
  }
};
